/* global $ */
/* eslint react/prop-types: 0 */
/* eslint class-methods-use-this:0 */
/* eslint css-modules/no-unused-class: 0 */
/* eslint react/no-did-mount-set-state: 0 */
/* eslint consistent-return: 0 */

import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './ModalIngresoDireccionActual.css';
import InputPlacesAutocomplete from '../FormComponents/InputPlacesAutocomplete/InputPlacesAutocomplete';
import * as telemedicinaActions from '../../actions/telemedicinaActions';

class ModalIngresoDireccionActual extends React.Component {
  state = {
    telefono1: this.props.oldTelephone.telefono1,
    telefono2: this.props.oldTelephone.telefono2,
    email: this.props.oldTelephone.email,
  };
  componentDidMount() {
    $('#modalIngresoDireccionActual').modal({
      backdrop: 'static',
      keyboard: false,
    });
    $('.close').hide();
  }

  validateCharacter = evt => {
    const regex = /[0-9]/;
    if (evt.keyCode !== 8 && evt.keyCode !== 9 && !regex.test(evt.key)) {
      return evt.preventDefault();
    }
  };

  handleChange = e => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  render() {
    return (
      <div className="modal fade" id="modalIngresoDireccionActual">
        <div className="modal-dialog">
          <div className={`${s.modalContent} modal-content`}>
            <div className={`${s.modalHeader} modal-header`}>
              <h6 className="modal-title" style={{ fontWeight: '600' }}>
                Por favor ingresá tu dirección actual y teléfono celular
              </h6>
            </div>
            <div className={`${s.modalBody} modal-body`}>
              <div className={`${s.regularText} text-left`}>
                Por tu seguridad necesitamos saber en que dirección te encontrás
                actualmente. Si la dirección precargada no coincide con tu
                dirección actual por favor modificala abajo. <br /> <br />
                <span className={`${s.boldText}`}>
                  La dirección solo la utilizaremos si durante la consulta tu
                  vida se encuentra en riesgo.
                </span>
                <br />
                <span className={`${s.boldText}`}>
                  <br />
                  Dirección actual
                </span>
                <br />
                <InputPlacesAutocomplete direccion={this.props.direccion} />
                <div className="d-flex justify-content-between flex-wrap">
                  <div>
                    <span className={`${s.boldText}`}>Número de Celular</span>
                    <input
                      type="text"
                      id="telefono1"
                      name="telefono1"
                      className="form-control"
                      value={this.state.telefono1}
                      onKeyDown={this.validateCharacter}
                      onChange={this.handleChange}
                    />
                  </div>
                  {/* <div>
                    <span className={`${s.boldText}`}>
                      Número de Celular(2)
                    </span>
                    <input
                      type="text"
                      id="telefono2"
                      name="telefono2"
                      className="form-control"
                      value={this.state.telefono2}
                      onKeyDown={this.validateCharacter}
                      onChange={this.handleChange}
                    />
                  </div> */}
                </div>
                {/* {this.props.velidateTel
                    ? <div className="w-100"><span className='text-danger'>Deben ser telefonos distintos</span></div>
                    : ''
                  }  */}
                <span className={`${s.boldText}`}>Correo</span>
                <input
                  type="text"
                  id="email"
                  name="email"
                  className="form-control"
                  defaultValue={this.state.email}
                  //  onKeyDown={this.ValidateMail}
                  onChange={this.handleChange}
                />
                {/* {this.props.valEmail
                 ? ''
                 : <span className='text-danger'>Debe ingresar un correo valido</span>
                } */}
                {this.props.validateSubmit ? (
                  <div className={`${s.text_danger}`}>
                    {' '}
                    {this.props.validateSubmit}{' '}
                  </div>
                ) : null}
              </div>
            </div>
            <div className={`${s.modalFooter} modal-footer`}>
              <button
                onClick={() => this.props.cleanDomicilio()}
                data-dismiss="modal"
                className={`${s.boton_blanco} ${s.robotoMedium} btn btn-default float-left`}
              >
                Cancelar
              </button>
              <button
                // data-dismiss="modal"
                className={`${s.boton_rojo} btn btn-default text-center`}
                // target="_blank"
                onClick={() =>
                  this.props.continuar(
                    $('#direccion').val(),
                    $('#telefono1').val(),
                    $('#telefono2').val(),
                    $('#email').val(),
                  )}
              >
                Iniciar Consulta
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  get_telefonos: state.telemedicina.get_telefonos,
  validateSubmit: state.telemedicina.validateSubmit,
  // linkDoc: state.telemedicina.linkDoc
});

export default connect(mapStateToProps, telemedicinaActions)(
  withStyles(s)(ModalIngresoDireccionActual),
);



// WEBPACK FOOTER //
// ./src/components/ModalIngresoDireccionActual/ModalIngresoDireccionActual.js